// extracted by mini-css-extract-plugin
export var body = "_mz-8";
export var button = "_mz-0";
export var closeButton = "_mz-5";
export var content = "_mz-3";
export var empty = "_mz-f";
export var grid = "_mz-c";
export var header = "_mz-4";
export var icon = "_mz-1";
export var option = "_mz-d";
export var optionSelected = "_mz-e";
export var overlay = "_mz-2";
export var searchIcon = "_mz-a";
export var searchInput = "_mz-b";
export var searchWrapper = "_mz-9";
export var title = "_mz-6";
export var visuallyHidden = "_mz-7";